import {
  KEY_PREFIX,
  readFromLocalStorage,
  removeFromLocalStorage,
  saveToLocalStorage,
} from "../../core-module/util/localStorageHandler";
import store from "../../../store";

const _keyToken = "Token",
  _keyUser = "User",
  _keyRole = "Role",
  _keyDeviceId = "DeviceId";

export const AUTH_TOKEN = `${KEY_PREFIX}_${_keyToken}`;

export const initAuthHelper = () => {
  try {
    store.commit("SET_AUTHENTICATED", isAuthenticated());
    store.commit("SET_AUTHENTICATED_USER", authUser());
    store.commit("SET_AUTHENTICATED_USER_ROLE", authRole());
  } catch (e) {
    console.log("authHelper.initAuthHelper:exception:", e.message);
  }
};

export const saveAuthUser = authUser => {
  try {
    saveToLocalStorage(_keyToken, authUser.token);
    store.commit("SET_AUTHENTICATED", true);
    saveUser(authUser.user);
    store.commit("SET_SUBSCRIPTION_INFO", authUser.subscriptionInfo);
  } catch (e) {
    console.log("authHelper.saveAuthUser:exception:", e.message);
  }
};

export const clearAuthUser = () => {
  try {
    removeFromLocalStorage(_keyToken);
    removeFromLocalStorage(_keyUser);
    removeFromLocalStorage(_keyRole);
    removeFromLocalStorage(_keyDeviceId);
    store.commit("SET_AUTHENTICATED", false);
    store.commit("SET_AUTHENTICATED_USER", "REMOVE");
    store.commit("SET_AUTHENTICATED_USER_ROLE", "REMOVE");
    store.commit("SET_SUBSCRIPTION_INFO", "REMOVE");
  } catch (e) {
    console.log("authHelper.clearAuthUser:exception:", e.message);
  }
};

export const saveUser = user => {
  try {
    saveToLocalStorage(_keyUser, user);
    saveToLocalStorage(_keyRole, user.role);
    store.commit("SET_AUTHENTICATED_USER", user);
    store.commit("SET_AUTHENTICATED_USER_ROLE", user.role);
  } catch (e) {
    console.log("authHelper.saveUser:exception:", e.message);
  }
};

export const isAuthenticated = () => readFromLocalStorage(_keyToken) != null;

export const authUser = () => readFromLocalStorage(_keyUser);

export const authRole = () => readFromLocalStorage(_keyRole) || "GUEST";

export const deviceId = () => {
  try {
    let savedDeviceId = readFromLocalStorage(_keyDeviceId);

    if (!savedDeviceId) {
      const navigator_info = window.navigator;
      const screen_info = window.screen;

      savedDeviceId = [
        navigator_info.mimeTypes.length,
        navigator_info.userAgent.replace(/\D+/g, ""),
        navigator_info.plugins.length,
        screen_info.height || "",
        screen_info.width || "",
        screen_info.pixelDepth || "",
      ].join("-");

      saveToLocalStorage(_keyDeviceId, savedDeviceId);
    }

    return savedDeviceId.toString();
  } catch (e) {
    console.log("authHelper.deviceId:exception:", e.message);
  }
};

export const isAuthenticatedRole = role => {
  return role === "EMPLOYEE";
};
